import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { useTranslation } from 'react-i18next';

export type PublicationBo = {
  id: number;
  reseller_id: number;
  reseller_name: string;
};

export type PublicationResponse = {
  result: PublicationBo[];
  count: number;
  total_results: number;
};

export const useGetPublication = (planId: number | undefined) => {
  const { t } = useTranslation();

  const fetchPublication = async (): Promise<PublicationResponse> => {
    if (!planId) {
      throw new Error(t('plan-id-is-not-defined'));
    }
    const response = await Axios.get<PublicationResponse>(
      `${GET_URL(planId.toString()).resellerPublications}`
    );
    return response.data;
  };

  return useQuery<PublicationResponse, AxiosError<BaseError>>(
    ['publication', planId],
    fetchPublication,
    {
      enabled: !!planId,
      useErrorBoundary: false
    }
  );
};
